var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EIconButton',_vm._g(_vm._b({attrs:{"icon":_vm.icon,"as":"a","icon-size":"s","variant":"bare","rounded":""}},'EIconButton',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }